import { useEffect, useState, forwardRef, useImperativeHandle, Suspense, lazy,useRef } from "react";
import { InputGroup } from "react-bootstrap";
import { AutoComplete } from "../AutoComplete/AutoComplete";
import ToolTip from "../ToolTip/Tooltip";
import { GridView } from "../GridView/GridView";
import useExceptionHandler from "../../Hooks/useExceptionHandler";
import usePaginationValuesWhere from "../../Hooks/usePaginationValuesWhere";
import {   
    buttonStyle,
    controlsProportion,
    initialWhere,
    initialWhereModal, 
} from "..";
import { AnimatedIconButton } from "../AnimatedIconButton/AnimatedIconButton";
import { SvgComponent } from "../SvgComponent/SvgComponent";
import {Simplebar} from "../Simplebar/Simplebar";
import "./Lookup.style.css";
import IconButton from "../IconButton/IconButton";
import {BUSCAR_ACTIVIDAD_ECONOMICA, BUSCAR_ACTIVIDAD_ECONOMICA_POR_ID} from "../../Utils";

export function ActividadEconomicaLookup({
                       initialValue = { id: "", value: "", label:"" },
                       onChange,
                       isDisabled,
                       isInput = false,
                       style = {},
                        placement = 'end'
                   }) {
    const DEFAULT_PAGINATION_VALUES = {
        EsPaginable: true,
        CantidadPorPagina: 15,
        EsOrdernable: true,
        OrderBy: "IdSec",
        EsAscendente: false,
    };

    const consultaActualId = useRef();
    const ref = useRef(null);
    const [showCanvas, setShowCanvas] = useState(false);
    const [rncListModal, setRncListModal] = useState([]);
    const [selectedValue, setSelectedValue] = useState({
        id: "",
        value: "",
        label: ""
    });
    const [whereModal, setWhereModal] = useState(initialWhereModal);
    const [pagination, setPagination] = useState({
        ...DEFAULT_PAGINATION_VALUES,
        Estatus: "",
        EsOrdernable: true,
        OrderBy: "Id",
    });
    const { setPaginationValuesWhere } = usePaginationValuesWhere();

    useEffect(() => {
        if (whereModal != initialWhereModal) {
            buscar();
        }
    }, [whereModal]);

    useEffect(() => {
        if (
            selectedValue != undefined &&
            selectedValue.value !== null &&
            selectedValue.value != ""
        ) {
            onChange(selectedValue);
        }
    }, [selectedValue]);

    useEffect(() => {
        if (
            initialValue.value &&
            initialValue.value != "" &&
            initialValue.value !== selectedValue.value
        ) {
            setValue();
        }
    }, [initialValue.value]);

    const buscar2 = (url, cuerpo) => {
        return new Promise(function (resolve, reject) {
            // eslint-disable-next-line no-undef
            Citrus.AJAX.getJSON(url, cuerpo, function (respuesta) {
                // eslint-disable-next-line no-undef
                var datos = $.parseJSON(respuesta.d);
                if (
                    datos &&
                    datos["Mensaje"] !== undefined &&
                    datos["Detalle"] !== undefined &&
                    datos["Interno"] !== undefined
                ) {
                    reject(datos);
                }
                resolve(datos);
            });
        });
    };

    function buscar() {
        const whereWithPaginationValues = { ...whereModal, ...pagination };
        const obtenerDatos = () => {
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = BUSCAR_ACTIVIDAD_ECONOMICA;
            buscar2(url, { where: {...whereWithPaginationValues} }).then((data) => {
                if (consultaId === consultaActualId.current) {
                    setPaginationValuesWhere(data, pagination, setPagination);
                    setRncListModal(data.Resultados);
                }
            });
        };
        obtenerDatos();
    }

    const setValue = () => {
        const obtenerDatos = () => {
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = BUSCAR_ACTIVIDAD_ECONOMICA_POR_ID;
            buscar2(url, {id: initialValue.value}).then((data) => {
                if (consultaId === consultaActualId.current) {
                    setSelectedValue({
                        id: data.Id,
                        value: data.Descripcion,
                        label: data.Descripcion,
                    });
                }
            });
        };
        obtenerDatos();
    };

    const handleCerrar = () => {
        setShowCanvas(false);
        setWhereModal(initialWhereModal);
    };

    const onPageIndexChanging = (pageNumber) => {
        setPagination((prevstate) => {
            return { ...prevstate, IndiceDePagina: pageNumber - 1 };
        });
        setWhereModal({ ...whereModal });
    };
    
    const getSuggestions = async (value) => {
        const inputValue = value.trim().toLowerCase();
        let resp;
        const consultaId = Math.random();
        consultaActualId.current = consultaId;
        const url = BUSCAR_ACTIVIDAD_ECONOMICA;
        await buscar2(url, { where: {...initialWhere, Nombre: inputValue} }).then((data) => {
            if (consultaId === consultaActualId.current) {
                resp = data.Resultados;
            }
        });
        return resp;
    };
    
    return (
        <div style={{paddingRight: '20px'}}>
            {!isInput ? (
                <InputGroup>
                    <div style={{ width: controlsProportion.input }}>
                        <AutoComplete
                            placeholder="Actividad Economica"
                            getList={getSuggestions}
                            parentValue={selectedValue}
                            setParentValue={setSelectedValue}
                            noBorderRadius={isInput}
                            isDisabled={isDisabled}
                            noFilterSuggested={true}
                        />
                    </div>
                    <div style={{ width: controlsProportion.button }}>
                        <AnimatedIconButton
                            size="40px"
                            height="18"
                            width="18"
                            useVendorTheme
                            message="Seleccionar Actividad Economica"
                            style={buttonStyle}
                            disabled={isDisabled}
                            iconName="search"
                            onClick={() => {
                                setShowCanvas(true);
                                setTimeout(() => {
                                    buscar();
                                }, 200);
                            }}
                        />
                    </div>
                </InputGroup>
            ) : (
                <>
                    <div style={{ width: controlsProportion.inputGroup }}>
                        <AutoComplete
                            placeholder="Actividad Economica"
                            getList={getSuggestions}
                            parentValue={selectedValue}
                            setParentValue={setSelectedValue}
                            noBorderRadius={isInput}
                            isDisabled={isDisabled}
                            noFilterSuggested={true}
                        />
                    </div>
                    <div style={{ width: controlsProportion.button }}>
                        <AnimatedIconButton
                            size="40px"
                            height="18"
                            width="18"
                            message="Seleccionar Actividad Economica"
                            style={buttonStyle}
                            disabled={isDisabled}
                            iconName="search"
                            useVendorTheme
                            onClick={() => {
                                setShowCanvas(true);
                                setTimeout(() => {
                                    buscar();
                                }, 200);
                            }}
                        />
                    </div>
                </>
            )}
            {showCanvas && (
                <Suspense>
                    <Simplebar
                        scroll
                        backdrop={true}
                        ref={ref}
                        placement={placement}
                        portal={false}
                        size="lg"
                        useLoading={true}
                        visible={showCanvas}
                        setShow={(e) => {
                            setShowCanvas(e);
                        }}
                        title="Seleccionar Actividad Economica"
                        btnLeft={{
                            show: false,
                            func: () => {},
                        }}
                        btnRight={{
                            show: false,
                            func: () => {},
                        }}
                        useVendorTheme
                    >
                        <GridView
                            pagination={pagination}
                            setPagination={setPagination}
                            allowPaging={pagination.EsPaginable}
                            pageSize={pagination.CantidadPorPagina}
                            pageIndex={pagination.IndiceDePagina}
                            lastPageNumber={pagination.PaginasTotal}
                            dataSource={rncListModal}
                            onPageIndexChanging={onPageIndexChanging}
                            where={whereModal}
                            setWhere={setWhereModal}
                        >
                            <GridView.Column
                                isSticky
                                bodyRenderer={(row) => {
                                    return (
                                        <div className="float-right">
                                            <IconButton
                                                onClick={() => {
                                                    setSelectedValue({
                                                        id: row.Id,
                                                        value: row.Descripcion,
                                                        label: row.Descripcion,
                                                    });
                                                    handleCerrar();
                                                }}
                                            >
                                                <ToolTip message="Seleccionar">
                                                    <div>
                                                        <SvgComponent
                                                            height="20"
                                                            width="20"
                                                            iconName="check"
                                                            fill="#f16101"
                                                        />
                                                    </div>
                                                </ToolTip>
                                            </IconButton>
                                        </div>
                                    );
                                }}
                            />
                            <GridView.Column
                                headerText="Descripcion"
                                dataField="Descripcion"
                                sortExpression="Descripcion"
                                width="600px"
                                searchField="Nombre"
                            />
                        </GridView>
                    </Simplebar>
                </Suspense>
            )}
        </div>
    );
}
